module.exports = __webpack_public_path__ + "static/media/loading.33495d0b.svg";